import React, { FC } from 'react'
import styles from './EmptyPageNotifier.module.scss'
import EmptyNotificationSidebar from '@assets/empty-notification-sidebar.png';
import { Trans } from 'react-i18next';
import { Typography } from '@material-ui/core';

export enum EEmptyPageNotifierTypes {
    EmptyNotification = 'empty-notification'
}

interface IEmptyPageNotifiers {
    notifierType: EEmptyPageNotifierTypes 
}

export const EmptyPageNotifiers:FC<IEmptyPageNotifiers> = ({notifierType}) => {


 const emptyNotificationMessage = () => {
    return (
        <>
          <div className={styles.empty_notification}>
            <img src={EmptyNotificationSidebar} />  
            <Typography variant="h4" className="heading_m">
              <Trans i18nKey="notification.emptyNotificationTitle" />
            </Typography>
            <Typography variant="body1" className="body_large">
              <Trans i18nKey="notification.emptyNotificationSubtitle" />
            </Typography>
          </div>
        </>
      );
    }   
 const getEmptyScreenMessages = (notifierType: EEmptyPageNotifierTypes) => {
    switch(notifierType) {
        case EEmptyPageNotifierTypes.EmptyNotification:
            return emptyNotificationMessage();
        default:
            return null;
    }
 }   

  return (
    <div className={styles.container}>
        {getEmptyScreenMessages(notifierType)}
    </div>
  )
}


export default EmptyPageNotifiers